// File: src/components/pages/static/Contact.jsx
// Publicly accessible — no authentication required

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import '../../../styles/unified.css';

const Contact = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth0();
  const handleBack = () => navigate(isAuthenticated ? '/dashboard' : '/');

  return (
    <div className="static-page">

      {/* Hero */}
      <div className="static-hero">
        <div className="static-hero-inner">
          <button className="static-back-btn" onClick={handleBack}>
            ← {isAuthenticated ? 'Back to Dashboard' : 'Back to Home'}
          </button>
          <div className="static-hero-icon">✉️</div>
          <div className="static-hero-badge">Get in Touch</div>
          <h1 className="static-hero-title">Contact Us</h1>
          <p className="static-hero-subtitle">
            Have a question or need help? We would love to hear from you.
            Reach out and we will get back to you as soon as possible.
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="static-container">

        <div className="static-card">
          <h2 className="static-card-title">
            <span className="static-card-title-icon">📬</span>
            Contact Details
          </h2>

          <div className="static-contact-row">
            <div className="static-contact-icon">📧</div>
            <div>
              <div className="static-contact-label">Email</div>
              <div className="static-contact-value">
                <a href="mailto:nbipinraj@bipzapp.com">nbipinraj@bipzapp.com</a>
              </div>
            </div>
          </div>

          <div className="static-contact-row">
            <div className="static-contact-icon">📞</div>
            <div>
              <div className="static-contact-label">Phone</div>
              <div className="static-contact-value">
                <a href="tel:+447423393876">+44 7423 39 3876</a>
              </div>
            </div>
          </div>

          <div className="static-contact-row">
            <div className="static-contact-icon">📍</div>
            <div>
              <div className="static-contact-label">Location</div>
              <div className="static-contact-value">Salisbury, England, UK</div>
            </div>
          </div>
        </div>

        <div className="static-card">
          <h2 className="static-card-title">
            <span className="static-card-title-icon">🕐</span>
            Response Times
          </h2>
          <p>
            We aim to respond to all enquiries as soon as possible.
          </p>
          {/*}
          <p>
            Our support hours are Monday to Friday, 9:00 am – 6:00 pm (GMT/BST).
            Emails received outside these hours will be responded to on the next
            working day.
          </p>
          */}
        </div>

        <div className="static-highlight">
          <div className="static-highlight-icon">💬</div>
          <p>
            Looking for help with a specific feature? Visit our{' '}
            <a href="/help" style={{ color: '#7c3aed', fontWeight: 600 }}>Help Center</a>{' '}
            for guides and answers to common questions before reaching out.
          </p>
        </div>

      </div>
    </div>
  );
};

export default Contact;
